import {Routes} from '@angular/router';
import {authGuard} from './auth.guard';
import {ShellComponent} from './shell/shell.component';
import {NycSyncPageComponent} from './features/nyc-sync/nyc-sync-page.component';
import {UsersPageComponent} from './features/users/users-page.component';
import {UserPageComponent} from './features/users/user-page.component';
import {SendTextMessagePageComponent} from './features/users/send-text-message-page.component';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'nyc-sync',
      },
      {
        path: 'nyc-sync',
        component: NycSyncPageComponent,
      },
      {
        path: 'users',
        component: UsersPageComponent,
      },
      {
        path: 'users/:userId',
        component: UserPageComponent,
      },
      {
        path: 'users/:userId/send-text-message',
        component: SendTextMessagePageComponent,
      },
    ],
  },
  {
    path: 'callback',
    redirectTo: '',
  },
];
